import { isPage } from '../utils/helpers.js';

// Widget Scripts
import slideshow from '../widgets/slideshow.js';
import cardWidget from '../widgets/cardWidget.js';
import imageTextCard from '../widgets/imageTextCard.js';
import infographic from '../widgets/infographic.js';
import seoWidget from '../widgets/seoWidget';
import videoWidget from './widgets/videoWidget.js';
import videoCard from './widgets/videoCard.js';
import scrollerSponsors from '../widgets/scrollerSponsors.js';

export function initWidgets() {
  if (isPage('ese-foundation-home')) {
    slideshow('foundationSlideshow', foundationSlideshowOpts);
    seoWidget({
      widgetNameVariable: 'foundationSeoWidget',
      widgetOptsVariable: foundationSeoWidgetOpts,
      useImageBackground: false,
      useDividers: false,
    });
    cardWidget({
      widgetName: 'foundationCardWidget',
      widgetOpts: foundationCardWidgetOpts,
      wrapContainerClass: 'foundationCardWidget-container-wrapper',
      showMoreButton: true,
      allLink: true,
    });
    imageTextCard('imageTextCard1', imageTextCard1Opts);
    infographic('foundationInfographic', foundationInfographicOpts, 3, 'Our Impact');
    imageTextCard('imageTextCard2', imageTextCard2Opts);
    videoCard();
    cardWidget({
      widgetName: 'foundationHotButtons',
      widgetOpts: foundationHotButtonsOpts,
      wrapContainerClass: 'foundationHotButtons-container-wrapper',
      showMoreButton: false,
      allLink: true,
    });
    scrollerSponsors('scroller-sponsors', scrollerSponsorsOpts);
    $(globalThis).on('load', function () {
      videoWidget();
    });
  }
}
